import { memo, useEffect } from "react";

import { useTransferPopup } from "@/hooks/use-transfer-popup";

import { TransferPopup } from "./TransferPopup";
import { ETransferPopupVariant } from "./types";

// NOTE: NSAI-7067 — mounted directly above a chat composer. Pavel's placement
// from NSAI-5939: the card sits in the page flow over the text field, so it
// never covers the composer's own controls — the overlap that got the first
// mobile popout pulled before merge (NSAI-5241: 72% of the send button sat
// under a card docked in the corner). Registering tells the floating fallback
// to stand down while this one is on screen. Matches the composer's own width
// so the two read as one column.
const TransferPopupDockComponent = (): JSX.Element => {
  const { registerDock } = useTransferPopup();

  useEffect(() => registerDock(), [registerDock]);

  return (
    <div
      className="mx-auto w-full empty:hidden xl:max-w-chat [&:not(:empty)]:mb-3"
      data-testid="transfer-popup-dock"
    >
      <TransferPopup variant={ETransferPopupVariant.DOCKED} />
    </div>
  );
};

export const TransferPopupDock = memo(TransferPopupDockComponent);
